// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// bootstrap styles import
import "bootstrap/dist/css/bootstrap.min.css"

// styles import
import "./src/assets/css/colors/default.css"
import "./src/assets/sass/App.scss"
import "./src/assets/css/style.css"

import "./src/assets/css/materialdesignicons.min.css"

// Highlighting for code blocks
// import "prismjs/themes/prism.css"

// Display a custom message once  service worker finds an update
// by displaying a confirm prompt asking the user whether they would
// like to refresh the page when an update is found
export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `muhammadilyaskpada.com has been updated. ` +
      `Reload to display the latest version?`
  )

  if (answer === true) {
    window.location.reload()
  }
}
